import React, { useEffect, useState } from 'react';
import Page1 from './components/Page1';

import { getApmcByDepartmentId, getExistedSchemesAplication, submitApmcFiles, submitForms } from '../../auth/services/privateapicalling';
// import { getApplicationExistencCheck } from '../../auth/services/privateapicalling';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import { Toast } from 'react-bootstrap';
import { toast, ToastContainer } from 'react-toastify';
// import Page2 from './components/Page2';
// import Page3 from './components/Page3';

 
 
// ---------------------------------- IDs ----------------------------------

const AllForms: React.FC = () => {

 
    const token = useSelector((state:any)=>state.auth.token);
    const userDetail = useSelector((state:any)=>state.auth.userDetails)
    const location = useLocation();
    const type= location.state?.type || null;
    
    const applicationId = location.state?.applicationId || null;
    const couchId = location.state?.couchId || null;
    const navigate = useNavigate()
    const [uploadLoading, setUploadLoading]=useState(false);
 
  const [existData ,setExistData] = useState<any | null>(null);
 
  
  const [step, setStep] = useState<number>(1);

 const [formData, setFormData] = useState<Record<string, Array<Record<string, any>>>>({});
 





//----------------------------------STEPS FOR NEXT & BACK----------------------------------

  const handleNext = (): void => {
    if (step < 3) setStep(step + 1);
    window.scrollTo({ top: 0, behavior: 'smooth' });

  };
 
  const handleBack = (): void => {
    if (step > 1) setStep(step - 1);
    window.scrollTo({ top: 0, behavior: 'smooth' });

  };

  // Properly typed helper function
  const getStepColor = (num: number): string => {
    return step >= num ? 'lightblue ' : 'white';
  };

  // Show tick icon if completed, else step number
const getStepContent = (stepIndex: number): React.ReactNode => {
  return step > stepIndex ? (
    <i className="fas fa-check text-white"></i> // font-awesome tick
  ) : (
    stepIndex
  );
};

const getStepStyle = (stepIndex: number): React.CSSProperties => {
  if (step > stepIndex) {
    return {
      backgroundColor: 'lightblue',
      border: '1px solid lightblue',
      color: 'white'
    };
  } else if (step === stepIndex) {
    return {
      backgroundColor: 'white',
      border: '2px solid #0d6efd', // Bootstrap primary blue
      color: '#0d6efd'
    };
  } else {
    return {
      backgroundColor: 'white',
      border: '1px solid #ccc',
      color: '#000'
    };
  }
};



// ----------------------------------Handle Inputs----------------------------------


  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>, fieldName: string) => {
    
  const { name, files } = e.target;
  
   if (files && files.length > 0) {
      const file = files[0];
      const fileName = file.name;
      // setItReturns((prev) => ({ ...prev, [name]: files[0] }));
      // setDisableButtonNext(true)
      const docId = formData[fieldName]?.find(item => item.documentName === name)?.docId || null;
      handleUpload(name,file, fieldName ,docId,fileName );
      // setDisableButtonNext(false)
    }


    
};

const handleUpload = async (documentName: string,file:any , fieldName:string , docId?: string | null,fileName?:string ) => {
    // if (!formData[fieldName]) return;
 
    const formData = new FormData();
    formData.append("file", file );
    formData.append("documentName", documentName);
    formData.append("fieldName", fieldName);
    formData.append("applicationId", applicationId);
    formData.append("schemeId", type);
 
 
    try {
      setUploadLoading(true)
      const res = await submitApmcFiles(formData, token, docId);
    
      
      if(res.success===false)
        {
        toast.error(res.message,  {
            position: "top-right",
            style: { fontSize: "1.2rem", padding: "16px" }
          })
  
      }
      else if (res.success && res.docId) {
      // Store docId and documentName in formData
          setFormData(prev => {
      const arr = Array.isArray(prev[fieldName]) ? [...prev[fieldName]] : [];
     const index = arr.findIndex(item => item.documentName === documentName);
if (index !== -1) {
  arr[index] = { docId: res?.docId, documentName: documentName, fileName: fileName };
} else {
  arr.push({ docId: res?.docId, documentName: documentName, fileName: fileName });
}
      return { ...prev, [fieldName]: arr };
    });
    toast.success("File uploaded successfully",  {
            position: "top-right",
            style: { fontSize: "1.2rem", padding: "16px" }
          });
      }
    } catch (error) {
      toast.error("File upload failed",  {
            position: "top-right",
            style: { fontSize: "1.2rem", padding: "16px" }
          });
    } finally {
      setUploadLoading(false)
    }
  };

const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>,fieldName?:string) => {
  const { name, value } = e.target;
  if (fieldName) {
    setFormData(prev => {
      const arr = Array.isArray(prev[fieldName]) ? [...prev[fieldName]] : [];
      const index = arr.findIndex(item => item.fieldName === name);
      if (index !== -1) {
        arr[index] = { ...arr[index], value: value };
      } else {
        arr.push({ value: value, fieldName: name });
      }
      return { ...prev, [fieldName]: arr };
    });
  } else {
    // Optionally handle case when fieldName is not provided
  }
};

  const handleSubmit = async() => {
    // Transform formData: { fieldName: [{...}, {...}] } => { fieldName: { data: [...] } }
    const annexureOne = Object.fromEntries(
      Object.entries(formData).map(([fieldName, arr]) => [
        fieldName,
        { data: arr }
      ])
    );

    const formDataToSubmit = {
      schemeId: String(type),
      departmentId: userDetail?.Department_ID,
      districtId: userDetail?.Department?.district_id,
      couchId: couchId,
      annexureOne: annexureOne,
    }
    //DONT FORGET REMOVE THIS FOR VALIDATIONS---------------------------------------------------------------------------------
    try{
      const response = await submitForms(formDataToSubmit, token, applicationId);
      
      toast.success(response?.message,  {
            position: "top-right",
            style: { fontSize: "1.2rem", padding: "16px" }
          })
      
          setTimeout(() => {
  navigate('/forms-application');
}, 1000);
    }catch(e){
      
  }
}


 
  return (
         
  <div className="page-wrapper ">
 
  {step === 1 && (
    <Page1
      onNext={handleNext}
      onBack={handleBack}
      formData={formData}
      setFormData={setFormData}
      handleFileChange={handleFileChange}
      handleInputChange={handleInputChange}
      handleSubmit={handleSubmit}
      type={type}
      uploadLoading={uploadLoading}
    />
  )}

<ToastContainer position='top-left' autoClose={3000}/>
</div>
  );
};
 
export default AllForms;
